var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicistBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 15.75C12.375 15.1287 12.8787 14.625 13.5 14.625H24.75C25.3713 14.625 25.875 15.1287 25.875 15.75C25.875 16.3713 25.3713 16.875 24.75 16.875H13.5C12.8787 16.875 12.375 16.3713 12.375 15.75ZM13.5 21.375H24.75C25.3713 21.375 25.875 20.8713 25.875 20.25C25.875 19.6287 25.3713 19.125 24.75 19.125H13.5C12.8787 19.125 12.375 19.6287 12.375 20.25C12.375 20.8713 12.8787 21.375 13.5 21.375ZM32.625 9V25.875C32.625 27.739 31.114 29.25 29.25 29.25H4.5C2.64206 29.25 1.13352 27.7484 1.125 25.8905V12.375C1.125 11.7537 1.62868 11.25 2.25 11.25C2.87132 11.25 3.375 11.7537 3.375 12.375V25.875C3.375 26.4963 3.87868 27 4.5 27C5.12132 27 5.625 26.4963 5.625 25.875V9C5.625 7.75736 6.63236 6.75 7.875 6.75H30.375C31.6176 6.75 32.625 7.75736 32.625 9ZM30.375 9H7.875V25.875C7.87556 26.2583 7.81039 26.6388 7.68234 27H29.25C29.8713 27 30.375 26.4963 30.375 25.875V9Z",
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicistBlue);
export default __webpack_public_path__ + "static/media/publicist-blue.05f6f74e947612eef9571abfe96fa09a.svg";
export { ForwardRef as ReactComponent };